exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-form[data-v-675018a6] {\n  margin-bottom: 20px;\n}\n.booking-order-table[data-v-675018a6] {\n  padding: 20px;\n}\n.pagination-container[data-v-675018a6] {\n  margin-top: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n", ""]);

// exports
